import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[xmAriaInvalid]',
    standalone: false
})
export class XmAriaInvalid implements OnInit, OnDestroy {
    private observer: MutationObserver;
    private element: HTMLElement;

    constructor(element: ElementRef) {
        Object.assign(this, { element: element.nativeElement });
    }

    public ngOnInit(): void {
        this.observer = new MutationObserver(this.processObserver.bind(this));
        this.observer.observe(this.element, {
            attributes: true,
            attributeFilter: [ 'class' ]
        });
    }

    public ngOnDestroy(): void {
        this.observer.disconnect();
    }

    private processObserver(records: MutationRecord[]): void {
        const classList: DOMTokenList = this.element.classList;

        records.forEach(() => {
            if (classList.contains('ng-untouched') || classList.contains('ng-pristine')) {
                return;
            }

            if (classList.contains('ng-valid')) {
                this.element.removeAttribute('aria-invalid');
            } else {
                this.element.setAttribute('aria-invalid', 'true');
            }
        });
    }
}
